import {Chat} from '../../../chat/Chat';
import {User} from '../User';
import {Item} from '../../item/Item';

 export class Friend extends User {
    public chat : Chat;
    public item : Item;
    public chatID : string;
    constructor(userObject:any){
        if(userObject == undefined )
            return;
        super(userObject);
        if(userObject['chatID']!= undefined){
            userObject['itemID'] = userObject.chatID;
            userObject['storageID'] = userObject.chatID;

        }
        if(userObject['friendID'] != undefined ){
            this.userID = userObject['friendID'];
        }
        this.chatID = userObject['chatID'];
        userObject['type'] = "chat";
        userObject['title'] = this.email;
        if(!userObject.item) {
            this.item = new Item(userObject);
        }

        
        else {
            this.item = new Item(userObject.item);
        }
//        this.chat = new Chat(userObject);
//        this.chat.title = this.email;
//        this.chat.type = "chat";
        
    }
    getSimpleModelOfFriend(){
        let friendData  = Object.assign({}, this);
        let friend = new Friend(friendData);
        if (this.chat)
        friend.chat = this.chat.getSimpleModel();
        if (this.item)
        friend.item = this.item.getSimpleModel();
        return friend;
    }
    
}